import { gql } from "@apollo/client"
import { DEMAND_LIST_FRAG } from "./demand.fragments.gql"
const DEMAND_DETAILS = gql`
  query DemandDetails($id: ID) {
    demandDetails(id: $id) {
      id
      name
      description
      isLive
      isVerified
      attachments {
        id
        mediaType
        url
      }
      varietyGroup {
        id
        name
      }
      date
      dateTill
      broadcastTime
      timeSlots {
        id
        quantity
        bookedQuantity
        quantityUnit {
          id
          name
        }
        timeSlot {
          id
          name
          fromTime
          toTime
        }
      }
      gradePrices {
        id
        price
        priceUnit {
          id
          name
        }
        priceLimit
        grade {
          id
          name
        }
      }
      depot {
        id
        name
      }
    }
  }
`
const DEMAND_LIST = gql`
  query allDemands(
    $search: String
    $first: Int
    $skip: Int
    $filter: DemandFilterInput
  ) {
    allDemands(query: $search, first: $first, skip: $skip, filter: $filter) {
      totalCount
      demands {
        ...DemandListFrag
      }
    }
  }
  ${DEMAND_LIST_FRAG}
`

const DEPARTMENT_DETAIL = gql`
  query departmentDetail($id: Int) {
    departmentDetails(departmentId: $id) {
      id
      name
      preferredDepot {
        id
        name
      }
    }
  }
`

export const DEMAND_LIST_INITIAL_VARIABLES = {
  first: 12,
  skip: 0,
  search: "",
  filter: {
    date_Gte: null,
    date_Lte: null,
    depot_Id: null,
    isLive: null,
    variety_Id: null,
  },
}
export { DEMAND_DETAILS, DEMAND_LIST, DEPARTMENT_DETAIL }
